module.exports = __webpack_public_path__ + "img/menuIcon11.6b53b45c.png";